import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import MenuSection from "./components/MenuSection";
import FeaturesSection from "./components/FeaturesSection";
import AccessSection from "./components/AccessSection";
import CtaSection from "./components/CtaSection";
import Footer from "./components/Footer";
import ScrollToTopButton from "@/components/feature/ScrollToTopButton";

export default function Home() {
  return (
    <div
      className="min-h-screen"
      style={{ background: "#0A0A0A", color: "#ffffff" }}
    >
      <Header />
      <main>
        <HeroSection />
        <MenuSection />
        <FeaturesSection />
        <AccessSection />
        <CtaSection />
      </main>
      <Footer />
      <ScrollToTopButton />
    </div>
  );
}
